import React, { Fragment } from 'react';
import 'normalize.css/normalize.css';
import { ThemeProvider } from '@material-ui/core/styles';
import { Global } from '@emotion/core';

import { theme, globalStyles } from './constants/style';
import { CommodityConverter } from './components/CommodityConverter';


const App = () => (
  <Fragment>
    <Global styles={globalStyles} />
    <ThemeProvider theme={theme}>
      <CommodityConverter />
    </ThemeProvider>
  </Fragment>
);

export default App;
